<template>
  <div>
    <div class="mass-action-settings">

      <el-select
        v-model="actionData.section_type"
        size="small"
        style="width: 500px"
        placeholder="Выберите секцию"
        @change="sectionChanged"
      >
        <el-option
          v-for="(sectionConfig, sectionType) in librarySections"
          :key="sectionType"
          :label="sectionConfig.showName"
          :value="sectionType"
        >
        </el-option>
      </el-select>

      <div
        v-if="actionData.section_type"
        style="margin-top: 10px"
      >
        <el-button
          style="margin-top: 10px"
          size="mini"
          icon="fas fa-plus"
          @click="addElementFromLibrary"
        >
          {{ $companyConfiguration.i18n.t('card', 'section_add_element_button') }}
        </el-button>


        <div style="margin-top: 10px">
          Выбранные цели:

          <el-table
            size="mini"
            border
            empty-text="Нет целей"
            style="width: 800px"
            :data="library_elements"
          >
            <el-table-column prop="name" label="Название цели"></el-table-column>
            <el-table-column label="Вес цели в карте" width="150">
              <template v-slot="scope">
                <el-input
                  v-model="actionData.ids_to_weight[scope.row.id]"
                  size="mini"
                  v-number-format
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column width="50" align="right">
              <template v-slot="scope">
                <el-button
                  type="text"
                  icon="far fa-trash-alt"
                  @click="deleteKPI(scope.row)"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>



      </div>


      <el-popconfirm
        style="margin-top: 25px; display: block"
        confirm-button-text='Да'
        cancel-button-text='нет'
        icon="el-icon-question"
        title="Вы уверены, что хотите добавить цель?"
        @confirm="doAction"
      >
        <el-button
          slot="reference"
          size="small"
          type="primary"
          :disabled="actionButtonDisabled"
        >
          Добавить
        </el-button>

      </el-popconfirm>

    </div>

    <mass-action-result
      v-if="result"
      :result="result"
    ></mass-action-result>

    <element-add-from-library-dialog
      ref="addElementFromLibraryDialog"
      @elements-selected="elementsSelected"
    >
    </element-add-from-library-dialog>
  </div>
</template>

<script>
import {ActionTemplateMixin} from "@/components/massActions/actionTemplates/ActionTemplateMixin";
import CardsStageSelect from "@/components/filters/cards/CardsStageSelect.vue";
import MassActionResult from "@/components/massActions/MassActionResult.vue";
import CardsStageNegotiationSelect from "@/components/filters/cards/CardsStageNegotiationSelect.vue";
import requestSender from "@/api/base/requestSender";
import ElementAddFromLibraryDialog from "@/components/cards/CardElementsBlock/ElementAddFromLibraryDialog.vue";

export default {
  name: "card-add-element-from-library-action",
  mixins: [ActionTemplateMixin],
  components: {ElementAddFromLibraryDialog, CardsStageNegotiationSelect, MassActionResult, CardsStageSelect},

  computed: {
    actionButtonDisabled() {
      return !this.library_elements.length;
    },
    librarySections(){
      let sections = {};
      for (const [key, value] of Object.entries(this.$companyConfiguration.cardSections.getSections())) {
        if( value.fromLibrary ){
          sections[key] = value;
        }
      }
      return sections;
    },
  },
  watch: {
    library_elements() {
      this.actionData.library_element_ids = this.library_elements.map(element => element.id);
    }
  },

  data() {
    return {
      library_elements: [],
      actionData: {
        section_type: null,
        library_element_ids: null,
        ids_to_weight: {},
      }
    }
  },
  methods: {
    sectionChanged(){
      this.library_elements = [];
    },

    addElementFromLibrary() {
      const libraryType = this.$companyConfiguration.cardSections.getSectionConfig(this.actionData.section_type)['fromLibrary'];
      this.$refs.addElementFromLibraryDialog.open(libraryType);
    },

    elementsSelected(elements){
      this.$refs.addElementFromLibraryDialog.close();
      this.library_elements = [...this.library_elements, ...elements];
    },

    deleteKPI(element){
      this.library_elements = this.library_elements.filter(e=>e!==element);
    },
  },
}
</script>
